import FacetHero from './FacetHero.vue'
import FacetGrid from './FacetGrid.vue'
import FacetTagMenu from './FacetTagMenu.vue'
import FacetTagMenuCount from './FacetTagMenuCount.vue'
import FacetContentBlocks from './FacetContentBlocks.vue'
import FacetRelatedGrid from './FacetRelatedGrid.vue'
import FacetShowAllFacets from './FacetShowAllFacets.vue'
import FacetSlider from './FacetSlider.vue'
import FacetRelatedCategories from './FacetRelatedCategories.vue'

export default {
  FacetHero,
  FacetGrid,
  FacetRelatedGrid,
  FacetTagMenu,
  FacetTagMenuCount,
  FacetContentBlocks,
  FacetShowAllFacets,
  FacetSlider,
  FacetRelatedCategories
}
